export default function Footer() {
  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="container mx-auto px-6 py-8">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">
            © 2025 Shorty.kr. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
